import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CookiesModalComponent } from '../components/cookies-modal/cookies-modal.component';
@Injectable({
  providedIn: 'root'
})
export class SeoService {

  cookiesConfig: any;
  cookiesAcepted: any;

  siteDomain: 'educacion.wwfbolivia.org';
  public siteName: 'WWF Bolivia - Educación Ambiental';
  constructor(
    public meta: Meta,
    public title: Title
  ) { }

  showCookiesPolicy() { }

  generateTags(config: any) {
    /*  config = {
       title: 'WWF Bolivia - Educación Ambiental',
       description: 'ESPACIOS EDUCATIVOS E INTERACTIVOS, CONOCE NUESTRAS ACTIVIDADES, MÁS DE 100 RECURSOS EDUCATIVOS PARA MAESTROS',
       image: 'assets/brand.png',
       slug: window.location.href,//url de la web
    //   ...config
     } */
    this.title.setTitle(config.title);

    this.meta.addTag({ name: 'twitter:card', content: 'summary' });
    this.meta.addTag({ name: 'twitter:site', content: '@wwf_bolivia' });
    this.meta.addTag({ name: 'twitter:title', content: config.title });
    this.meta.addTag({ name: 'twitter:description', content: config.description });
    this.meta.addTag({ name: 'twitter:image', content:  config.image ? config.image : '/assets/brand.png'  });
    this.meta.addTag({ name: 'twitter:image:alt', content:  config.imagealt ? config.imagealt : 'Educación Ambiental WWF Bolivia' });

    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:title', content: config.title });
    this.meta.updateTag({ property: 'og:description', content: config.description });
    this.meta.updateTag({ property: 'og:image', content: config.image });
    this.meta.updateTag({ property: 'og:image:alt', content: config.imagealt ? config.imagealt : 'Educación Ambiental WWF Bolivia' });
    this.meta.updateTag({ property: 'og:url', content: config.slug });
  }



}
